// ------dev-------
// // ดีงข้อมูลจาก server ibm
// const GET_LOAN_FROM_SERVER_IBM = "/lawyer/server/loans";

// //ดึงสัญญาทั้งหมดที่อยู่ใน server lawyers db
// const GET_ALL_LOAN = "/lawyer/dev/api/loans";

// ///ดึงสัญญาตาม contno ที่อยู่ใน server lawyers
// const GET_LOAN_BY_CONTNO = "/lawyer/dev/api/loans/";

// //ดึงจำนวนงานที่ users รับงาน
// const GET_JOB_COUNT = "/lawyer/dev/api/loans/notics/count";

// //ดึงจำนานงานที่กำลังดำเนินการ
// const GET_JOB_IN_PROGRESS = "/lawyer/dev/api/jobs";

// //ดึงจำนานงานที่กำลังดำเนินการตามสถานะ
// const GET_JOB_IN_PROGRESS_BY_STATUS = "/lawyer/dev/api/jobs/";

// //นำข้อมูลเข้า db lawyers
// const POST_LOAN_IN_LAWYERS_DB = "/lawyer/dev/api/loans";

// //เปลี่ยนสถานะสัญญา
// const POST_STATUS = "/lawyer/dev/api/loans/status";

// //อัพเดทสถานะสัญญา
// const PUT_STATUS = "/lawyer/dev/api/loans/status";

// //ดึงข้อมูลแบบคำฟ้อง
// const GET_LAWSUIT_DETAIL_BY_ID = `/lawyer/dev/api/lawsuits/`;
// const GET_LAWSUIT_LIST = `/lawyer/dev/api/lawsuits`;
// //อัพเดทข้อมูลคำฟ้อง
// const PUT_LAWSUIT_DETAIL = `/lawyer/dev/api/lawsuits`;
// const GET_LAWSUIT_DETAIL_BY_LOAN = `/lawyer/dev/api/lawsuits/loan/`;

// //ดึงข้อมูลสืบทรัพย์
// const GET_INVESTIGATE_BY_LAWSUIT = `/lawyer/dev/api/investigate-properties/`;
// const GET_INVESTIGATE_LIST = `/lawyer/dev/api/investigate-properties`;
// //สร้างข้อมูลสืบทรัพย์
// const POST_INVESTIGATE_LOG = `/lawyer/dev/api/investigate-log`;
// const POST_INVESTIGATE_ITEM = `/lawyer/dev/api/investigate-properties`;
// //อัพเดทข้อมูลสืบทรัพย์
// const PUT_INVESTIGATE_LOG = `/lawyer/dev/api/investigate-log`;
// const PUT_INVESTIGATE_ITEM_BY_ID = `/lawyer/dev/api/investigate-properties`;
// //ดึงข้อมูลเพื่อสืบทรัพย์
// const GET_INVESTIGATE_LOANS_LIST = `/lawyer/dev/api/investigate-properties/loans/list`;
// //ข้อมูลลักษณะที่ดิน
// const GET_LAND_DETAIL_LIST = `/lawyer/dev/api/investigate-properties/details/list`;
// //หาข้อมูลการสืบทรัพย์
// const GET_LAND_BY_DATE = `/lawyer/dev/api/investigate-properties/date-between`;

// //สืบก่อนฟ้อง
// const POST_PRE_INVESTIGATE_LOG = `/lawyer/dev/api/pre-investigate-assets`;
// const POST_PRE_INVESTIGATE_REPORT = `/lawyer/dev/api/pre-investigate-assets-report`;

// //ข้อมูลทั้งหมดของ id
// const GET_WORK_LOG_DETAIL_BY_ID = `/lawyer/dev/api/worklogs/`;

// //คำพิพากษา
// const POST_JUDGE = `/lawyer/dev/api/judgements`;
// const PUT_JUDGE = `/lawyer/dev/api/judgements`;
// const GET_JUDGE_BY_ID = `/lawyer/dev/api/judgements/`;
// const GET_JUDGE_LIST = `/lawyer/dev/api/judgements`;

// //ข้อมูลจำเลย
// const POST_JUDGE_DEFENDANTS = `/lawyer/dev/api/judgement-defendants`;
// const PUT_JUDGE_DEFENDANTS = `/lawyer/dev/api/judgement-defendants`;
// const GET_JUDGE_DEFENDANTS_BY_ID = `/lawyer/dev/api/judgement-defendants/`;

// //ข้อมูลจทำยอม
// const POST_AGREEMENTS = `/lawyer/dev/api/agreements/`;
// const PUT_AGREEMENTS = `/lawyer/dev/api/agreements`;
// const GET_AGREEMENTS_BY_ID = `/lawyer/dev/api/agreements/`;

// //notice
// const POST_PARCELS = `/lawyer/dev/api/parcels`;
// const PUT_PARCELS = `/lawyer/dev/api/parcels`;
// const GET_PARCELS = `/lawyer/dev/api/parcels/worklogs/`;

// //ems terminate
// const POST_CANCEL = `/lawyer/dev/api/cancel-contracts`;
// const PUT_CANCEL = `/lawyer/dev/api/cancel-contracts`;
// const GET_CANCEL = `/lawyer/dev/api/cancel-contracts`;

// //expenses
// const POST_EXPENSES = `/lawyer/dev/api/expenses`;
// const PUT_EXPENSES = `/lawyer/dev/api/expenses/`;
// const GET_EXPENSES_LIST = `/lawyer/dev/api/expenses`;
// const GET_EXPENSES_CONTNO_LIST = "/lawyer/dev/api/expenses/contract-list";
// const GET_EXPENSES_LOAN_ID = `/lawyer/dev/api/expenses/loan/`;
// const GET_EXPENSES_CONTNO = `/lawyer/dev/api/expenses/contract/`;
// const POST_DELETE_ID = `/lawyer/dev/api/expenses/`;
// const GET_EXPENSE_REF_GROUP = `/lawyer/dev/api/expenses/reference-list`;
// const GET_EXPENSE_TYPE_LIST = "/lawyer/dev/api/expenses/types";

// //expenses status
// const POST_EXPENSES_REFERENCE = `/lawyer/dev/api/expenses-reference`;
// const PUT_EXPENSES_REFERENCE = `/lawyer/dev/api/expenses-reference`;
// const GET_EXPENSES_REFERENCE = `/lawyer/dev/api/expenses/reference-list`;

// //execute
// const POST_EXECUTE_CASE = "/lawyer/dev/api/execute-case";
// const PUT_EXECUTE_CASE = "/lawyer/dev/api/execute-case";
// const GET_EXECUTE_CASE = "/lawyer/dev/api/execute-case";

// //ดึง users ในระบบ
// const GET_LAWYERS_LIST = "/lawyer/api/users";
// const GET_COMPANIES_LIST = "/lawyer/api/companies";
// const GET_ROLE_LIST = "/lawyer/api/roles";
// const GET_USERS_LIST = "/lawyer/api/users";
// const GET_BY_ID = "/lawyer/api/users/";
// const GET_SELL_STATUS = "/lawyer/dev/api/sale-status";

// //post
// const LOG_IN = `/lawyer/dev/api/login`;
// const REGISTER = `/lawyer/dev/api/register`;
// const POST_USER = `/lawyer/dev/api/users`;
// const PUT_USER_UPDATE = `/lawyer/dev/api/customers`;

// //รับเงินลูกค้า
// const POST_RECEIVE_PAYMENT = `/lawyer/dev/api/payment-logs`;
// const PUT_RECEIVE_PAYMENT = `/lawyer/dev/api/payment-logs`;
// const GET_RECEIVE_PAYMENT = `/lawyer/dev/api/payment-logs`;
// const GET_RECEIVE_PAYMENT_BY_PARAMS = `/lawyer/dev/api/payment-logs`;
// const DELETE_RECEIVE_PAYMENT_BY_ID = `/lawyer/dev/api/payment-logs/`;

// //all details
// const GET_DETAILS = `/lawyer/dev/api/all-details?contractNo=`;

// //method delete
// const DELETE_WORKLOG = `/lawyer/dev/api/worklogs/`;
// const DELETE_CANCEL_CONTRACTS = `/lawyer/dev/api/cancel-contracts/`;
// const DELETE_PARCELS = `/lawyer/dev/api/parcels/`;
// const DELETE_AGREEMENTS = `/lawyer/dev/api/agreements/`;
// const DELETE_JUDGEMENTS = `/lawyer/dev/api/judgements/`;
// const DELETE_JUDGEMENT_DEFENDANTS = `/lawyer/dev/api/judgement-defendants/`;
// const DELETE_INVESTIGATE_PROPERTIES = `/lawyer/dev/api/investigate-properties/`;
// const DELETE_EXPENSES = `/lawyer/dev/api/expenses/`;

// const baseUrl = "https://shark-app-j9jc9.ondigitalocean.app";
// const baseUrl = "https://assessmentsapi-317162740896.asia-southeast3.run.app";

// const TOKEN = localStorage.getItem("TOKEN");
// const HEADERS_EXPORT = {
//   "x-access-token": TOKEN,
// };

// const HEADERS_EXPORT_BEN = {
//   "Content-Type": "application/json",
//   Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
// };

// const HEADERS_LOGIN = {
//   "Content-Type": "application/json",
// };

// //get ข้อมูลบอกเลิกสัญญาเบน
// const POST_TERMINATE_CONTRACT = `https://api-nikki-539174983798.asia-southeast1.run.app/api-lawyer/nikki`;
// const POST_TERMINATE_CONTRACT_RECORD = `https://api-nikki-539174983798.asia-southeast1.run.app/api-lawyer/nikki2`;
// const POST_TERMINATE_BY_CONTRACT = `https://api-nikki-539174983798.asia-southeast1.run.app/api-lawyer/detail-contno`;

// //ค้นหาสัญญา เบน
// const POST_LOAN_DB2 =
//   "https://api-nikki-539174983798.asia-southeast1.run.app/api-lawyer/search-contno";

// //ข้อมูลการผ่อน เส้น 1,3,8(ที่ดิน)
// const POST_DETAIL_PAYMENT =
//   "https://api-nikki-539174983798.asia-southeast1.run.app/api-lawyer/tonbalance";

// //ข้อมูลการผ่อน 8(ไม่ใช่ดิน)
// const POST_DETAIL_PAYMENT_LEASING =
//   "https://api-nikki-539174983798.asia-southeast1.run.app/api-lawyer/leasing";

// //หาสัญญาที่ขาดการติดต่อเพื่อส่งสืบทรัพย์ (60 ,120, 180)
// const POST_PRE_INVESTIGATE_CHECK =
//   "https://api-nikki-539174983798.asia-southeast1.run.app/api-lawyer/check-miss-call-";

// //memo สืบทรัพย์
// const POST_MEMO =
//   "https://api-nikki-539174983798.asia-southeast1.run.app/api-lawyer/load-memo1";

// //หาทุนทรัพย์
// const POST_LITIGATION_FUNDS =
//   "https://api-nikki-1024031113167.asia-southeast1.run.app/api-lawyer/getleasingcase";

// const BASE_URL_BEN =
//   "https://api-asset-investigation-539174983798.asia-southeast1.run.app";
// const POST_CANCEL_LIST = "/api-new/load-work-cancel-contract-new";
// const POST_NEW_LOAN = "/api-new/loan-new";

// //get GeoThailand ของเอื้อ
// const GET_PROVICE = `https://eua-i67f6gaaqa-as.a.run.app/Api/provinces`;
// const GET_DISTRICT = `https://eua-i67f6gaaqa-as.a.run.app/Api/districted/`;
// const GET_SUB_DISTRICT = `https://eua-i67f6gaaqa-as.a.run.app/Api/subdistricted/`;
// const GET_ZIPCODE = `https://eua-i67f6gaaqa-as.a.run.app/Api/zipcodes/`;

// //get GeoThailand ที่ดิน
// const GET_PROVICE_LAND = `https://onemoney.ngrok.app/GetProvince`;
// const POST_DISTRICT_LAND = `https://onemoney.ngrok.app/GetAmphur`;
// const POST_CALCULATE_LAND = `https://onemoney.ngrok.app/AllData`;

// //get GeoThailand ดริฟ
// const GET_PROVICE_DB = `/lawyer/lands/provinces`;
// const POST_DISTRICT_DB = `/lawyer/lands/districts`;
// const POST_SUB_DISTRICT_DB = `/lawyer/lands/sub-districts`;

// // court area
// const GET_COURT_AREA = `/lawyer/lands/court`;
// // geo ben
// const GET_GEO_ALL = `${BASE_URL_BEN}/api-new/data-area`;

// const UPLOAD_IMG_WORK_CANCEL = `https://api-uploadimage-lawyer-539174983798.asia-southeast1.run.app/apimg-pdf/upload-pdf`; // อัพโหลด PDF จดหมายตอบรับ
// const LOADDATA_WORK_CANCEL = `https://api-asset-investigation-1024031113167.asia-southeast1.run.app/api-ems/load-ems-pdf`; // โหลดข้อมูลจดหมายตอบรับ
// const GET_BATCH = `https://api-asset-investigation-1024031113167.asia-southeast1.run.app/api-ems/get-batch`; // โหลดข้อมูลจดหมายตอบรับแบ่งวันที่

// const POST_ADD_ADDRESS = "/lawyer/dev/api/address";
// const PUT_ADD_ADDRESS = "/lawyer/dev/api/address";

// const POST_CEO_CHECK_CONTNO_MISS_CALL = `${BASE_URL_BEN}/api-lawyer/contno-miss-call`;
// const GET_CEO_CHECK_MAIN_STATUS = `${baseUrl}/lawyer/api/dashboard/main-status`;
// const POST_CEO_CHECK_SUMMARY_MISS_CALL = `${BASE_URL_BEN}/api-lawyer/sum-balanc-smpay`;

// export {
//   PUT_INVESTIGATE_ITEM_BY_ID,
//   POST_INVESTIGATE_ITEM,
//   GET_LAND_DETAIL_LIST,
//   GET_INVESTIGATE_LOANS_LIST,
//   PUT_USER_UPDATE,
//   HEADERS_LOGIN,
//   GET_LOAN_FROM_SERVER_IBM,
//   GET_ALL_LOAN,
//   GET_LOAN_BY_CONTNO,
//   GET_LAWYERS_LIST,
//   GET_JOB_COUNT,
//   GET_JOB_IN_PROGRESS,
//   GET_JOB_IN_PROGRESS_BY_STATUS,
//   POST_LOAN_IN_LAWYERS_DB,
//   POST_STATUS,
//   PUT_STATUS,
//   HEADERS_EXPORT,
//   baseUrl,
//   GET_LAWSUIT_DETAIL_BY_LOAN,
//   PUT_LAWSUIT_DETAIL,
//   GET_INVESTIGATE_BY_LAWSUIT,
//   GET_INVESTIGATE_LIST,
//   POST_INVESTIGATE_LOG,
//   PUT_INVESTIGATE_LOG,
//   LOG_IN,
//   REGISTER,
//   GET_WORK_LOG_DETAIL_BY_ID,
//   POST_JUDGE,
//   PUT_JUDGE,
//   GET_JUDGE_BY_ID,
//   GET_JUDGE_LIST,
//   POST_JUDGE_DEFENDANTS,
//   PUT_JUDGE_DEFENDANTS,
//   GET_JUDGE_DEFENDANTS_BY_ID,
//   GET_COMPANIES_LIST,
//   POST_AGREEMENTS,
//   PUT_AGREEMENTS,
//   GET_AGREEMENTS_BY_ID,
//   GET_LAWSUIT_DETAIL_BY_ID,
//   GET_LAWSUIT_LIST,
//   GET_ROLE_LIST,
//   GET_USERS_LIST,
//   GET_BY_ID,
//   POST_USER,
//   GET_PROVICE,
//   GET_DISTRICT,
//   GET_SUB_DISTRICT,
//   GET_ZIPCODE,
//   GET_DETAILS,
//   GET_PROVICE_LAND,
//   POST_DISTRICT_LAND,
//   POST_CALCULATE_LAND,
//   POST_PARCELS,
//   PUT_PARCELS,
//   GET_PARCELS,
//   POST_TERMINATE_CONTRACT,
//   POST_TERMINATE_CONTRACT_RECORD,
//   POST_TERMINATE_BY_CONTRACT,
//   POST_CANCEL,
//   PUT_CANCEL,
//   GET_CANCEL,
//   POST_EXPENSES,
//   PUT_EXPENSES,
//   GET_EXPENSES_LIST,
//   GET_EXPENSES_LOAN_ID,
//   GET_EXPENSES_CONTNO,
//   POST_DELETE_ID,
//   GET_EXPENSES_CONTNO_LIST,
//   GET_EXPENSE_REF_GROUP,
//   POST_LOAN_DB2,
//   POST_DETAIL_PAYMENT,
//   GET_EXPENSE_TYPE_LIST,
//   GET_SELL_STATUS,
//   POST_EXECUTE_CASE,
//   PUT_EXECUTE_CASE,
//   GET_EXECUTE_CASE,
//   DELETE_WORKLOG,
//   DELETE_CANCEL_CONTRACTS,
//   DELETE_PARCELS,
//   DELETE_AGREEMENTS,
//   DELETE_JUDGEMENTS,
//   DELETE_JUDGEMENT_DEFENDANTS,
//   DELETE_INVESTIGATE_PROPERTIES,
//   DELETE_EXPENSES,
//   POST_EXPENSES_REFERENCE,
//   PUT_EXPENSES_REFERENCE,
//   GET_EXPENSES_REFERENCE,
//   POST_DETAIL_PAYMENT_LEASING,
//   GET_PROVICE_DB,
//   POST_DISTRICT_DB,
//   POST_SUB_DISTRICT_DB,
//   POST_PRE_INVESTIGATE_CHECK,
//   POST_RECEIVE_PAYMENT,
//   PUT_RECEIVE_PAYMENT,
//   GET_RECEIVE_PAYMENT,
//   GET_RECEIVE_PAYMENT_BY_PARAMS,
//   DELETE_RECEIVE_PAYMENT_BY_ID,
//   POST_PRE_INVESTIGATE_LOG,
//   POST_PRE_INVESTIGATE_REPORT,
//   POST_MEMO,
//   HEADERS_EXPORT_BEN,
//   POST_LITIGATION_FUNDS,
//   BASE_URL_BEN,
//   POST_CANCEL_LIST,
//   POST_NEW_LOAN,
//   GET_LAND_BY_DATE,
//   UPLOAD_IMG_WORK_CANCEL,
//   LOADDATA_WORK_CANCEL,
//   GET_BATCH,
//   GET_COURT_AREA,
//   GET_GEO_ALL,
//   POST_ADD_ADDRESS,
//   PUT_ADD_ADDRESS,
//   POST_CEO_CHECK_CONTNO_MISS_CALL,
//   GET_CEO_CHECK_MAIN_STATUS,
//   POST_CEO_CHECK_SUMMARY_MISS_CALL,
// };

// ----production-----
//ดีงข้อมูลจาก server ibm
const GET_LOAN_FROM_SERVER_IBM = "/lawyer/server/loans";

//ดึงสัญญาทั้งหมดที่อยู่ใน server lawyers db
const GET_ALL_LOAN = "/lawyer/api/loans";

//ดึงสัญญาตาม contno ที่อยู่ใน server lawyers
const GET_LOAN_BY_CONTNO = "/lawyer/api/loans/";

//ดึงจำนวนงานที่ users รับงาน
const GET_JOB_COUNT = "/lawyer/api/loans/notics/count";

//ดึงจำนานงานที่กำลังดำเนินการ
const GET_JOB_IN_PROGRESS = "/lawyer/api/jobs";

//ดึงจำนานงานที่กำลังดำเนินการตามสถานะ
const GET_JOB_IN_PROGRESS_BY_STATUS = "/lawyer/api/jobs/";

//นำข้อมูลเข้า db lawyers
const POST_LOAN_IN_LAWYERS_DB = "/lawyer/api/loans";

//เปลี่ยนสถานะสัญญา
const POST_STATUS = "/lawyer/api/loans/status";

//อัพเดทสถานะสัญญา
const PUT_STATUS = "/lawyer/api/loans/status";

//ดึงข้อมูลแบบคำฟ้อง
const GET_LAWSUIT_DETAIL_BY_ID = `/lawyer/api/lawsuits/`;
const GET_LAWSUIT_LIST = `/lawyer/api/lawsuits`;
//อัพเดทข้อมูลคำฟ้อง
const PUT_LAWSUIT_DETAIL = `/lawyer/api/lawsuits`;
const GET_LAWSUIT_DETAIL_BY_LOAN = `/lawyer/api/lawsuits/loan/`;

//ดึงข้อมูลสืบทรัพย์
const GET_INVESTIGATE_BY_LAWSUIT = `/lawyer/api/investigate-properties/`;
const GET_INVESTIGATE_LIST = `/lawyer/api/investigate-properties`;
//สร้างข้อมูลสืบทรัพย์
const POST_INVESTIGATE_LOG = `/lawyer/api/investigate-log`;
const POST_INVESTIGATE_ITEM = `/lawyer/api/investigate-properties`;
//อัพเดทข้อมูลสืบทรัพย์
const PUT_INVESTIGATE_LOG = `/lawyer/api/investigate-log`;
const PUT_INVESTIGATE_ITEM_BY_ID = `/lawyer/api/investigate-properties`;
//ดึงข้อมูลเพื่อสืบทรัพย์
const GET_INVESTIGATE_LOANS_LIST = `/lawyer/api/investigate-properties/loans/list`;
//ข้อมูลลักษณะที่ดิน
const GET_LAND_DETAIL_LIST = `/lawyer/api/investigate-properties/details/list`;

// //หาข้อมูลการสืบทรัพย์
const GET_LAND_BY_DATE = `/lawyer/api/investigate-properties/date-between`;

//สืบก่อนฟ้อง
const POST_PRE_INVESTIGATE_LOG = `/lawyer/api/pre-investigate-assets`;
const POST_PRE_INVESTIGATE_REPORT = `/lawyer/api/pre-investigate-assets-report`;

//ข้อมูลทั้งหมดของ id
const GET_WORK_LOG_DETAIL_BY_ID = `/lawyer/api/worklogs/`;

//คำพิพากษา
const POST_JUDGE = `/lawyer/api/judgements`;
const PUT_JUDGE = `/lawyer/api/judgements`;
const GET_JUDGE_BY_ID = `/lawyer/api/judgements/`;
const GET_JUDGE_LIST = `/lawyer/api/judgements`;

//ข้อมูลจำเลย
const POST_JUDGE_DEFENDANTS = `/lawyer/api/judgement-defendants`;
const PUT_JUDGE_DEFENDANTS = `/lawyer/api/judgement-defendants`;
const GET_JUDGE_DEFENDANTS_BY_ID = `/lawyer/api/judgement-defendants/`;

//ข้อมูลจทำยอม
const POST_AGREEMENTS = `/lawyer/api/agreements/`;
const PUT_AGREEMENTS = `/lawyer/api/agreements`;
const GET_AGREEMENTS_BY_ID = `/lawyer/api/agreements/`;

//notice
const POST_PARCELS = `/lawyer/api/parcels`;
const PUT_PARCELS = `/lawyer/api/parcels`;
const GET_PARCELS = `/lawyer/api/parcels/worklogs/`;

//ems terminate
const POST_CANCEL = `/lawyer/api/cancel-contracts`;
const PUT_CANCEL = `/lawyer/api/cancel-contracts`;
const GET_CANCEL = `/lawyer/api/cancel-contracts`;

// expenses
const POST_EXPENSES = `/lawyer/api/expenses`;
const PUT_EXPENSES = `/lawyer/api/expenses/`;
const GET_EXPENSES_LIST = `/lawyer/api/expenses`;
const GET_EXPENSES_CONTNO_LIST = "/lawyer/api/expenses/contract-list";
const GET_EXPENSES_LOAN_ID = `/lawyer/api/expenses/loan/`;
const GET_EXPENSES_CONTNO = `/lawyer/api/expenses/contract/`;
const POST_DELETE_ID = `/lawyer/api/expenses/`;
const GET_EXPENSE_REF_GROUP = `/lawyer/api/expenses/reference-list`;

const GET_EXPENSE_TYPE_LIST = "/lawyer/api/expenses/types";

// expenses status
const POST_EXPENSES_REFERENCE = `/lawyer/api/expenses-reference`;
const PUT_EXPENSES_REFERENCE = `/lawyer/api/expenses-reference`;
const GET_EXPENSES_REFERENCE = `/lawyer/api/expenses/reference-list`;

// execute;
const POST_EXECUTE_CASE = "/lawyer/api/execute-case";
const PUT_EXECUTE_CASE = "/lawyer/api/execute-case";
const GET_EXECUTE_CASE = "/lawyer/api/execute-case";

//ดึง users ในระบบ
const GET_LAWYERS_LIST = "/lawyer/api/users";
const GET_COMPANIES_LIST = "/lawyer/api/companies";
const GET_ROLE_LIST = "/lawyer/api/roles";
const GET_USERS_LIST = "/lawyer/api/users";
const GET_BY_ID = "/lawyer/api/users/";
const GET_SELL_STATUS = "/lawyer/api/sale-status";

//post
const LOG_IN = `/lawyer/api/login`;
const REGISTER = `/lawyer/api/register`;
const POST_USER = `/lawyer/api/users`;
const PUT_USER_UPDATE = `/lawyer/api/customers`;

//all details
const GET_DETAILS = `/lawyer/api/all-details?contractNo=`;

//รับเงินลูกค้า
const POST_RECEIVE_PAYMENT = `/lawyer/api/payment-logs`;
const PUT_RECEIVE_PAYMENT = `/lawyer/api/payment-logs`;
const GET_RECEIVE_PAYMENT = `/lawyer/api/payment-logs`;
const GET_RECEIVE_PAYMENT_BY_PARAMS = `/lawyer/api/payment-logs`;
const DELETE_RECEIVE_PAYMENT_BY_ID = `/lawyer/api/payment-logs/`;

// method delete
const DELETE_WORKLOG = `/lawyer/api/worklogs/`;
const DELETE_CANCEL_CONTRACTS = `/lawyer/api/cancel-contracts/`;
const DELETE_PARCELS = `/lawyer/api/parcels/`;
const DELETE_AGREEMENTS = `/lawyer/api/agreements/`;
const DELETE_JUDGEMENTS = `/lawyer/api/judgements/`;
const DELETE_JUDGEMENT_DEFENDANTS = `/lawyer/api/judgement-defendants/`;
const DELETE_INVESTIGATE_PROPERTIES = `/lawyer/api/investigate-properties/`;
const DELETE_EXPENSES = `/lawyer/api/expenses/`;

// const baseUrl = "https://shark-app-j9jc9.ondigitalocean.app";
const baseUrl = "https://assessmentsapi-317162740896.asia-southeast3.run.app";

const TOKEN = localStorage.getItem("TOKEN");
const HEADERS_EXPORT = {
  "x-access-token": TOKEN,
};

const HEADERS_LOGIN = {
  "Content-Type": "application/json",
};

const HEADERS_EXPORT_BEN = {
  "Content-Type": "application/json",
  Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
};

const BASE_URL_BEN = "https://api-nikki-1024031113167.asia-southeast1.run.app";

const POST_TERMINATE_CONTRACT = `${BASE_URL_BEN}/api-lawyer/nikki`;
const POST_TERMINATE_CONTRACT_RECORD = `${BASE_URL_BEN}/api-lawyer/nikki2`;
const POST_TERMINATE_BY_CONTRACT = `${BASE_URL_BEN}/api-lawyer/detail-contno`;

// ค้นหาสัญญา เบน
const POST_LOAN_DB2 = `${BASE_URL_BEN}/api-lawyer/search-contno`;

//ข้อมูลการผ่อน เส้น 1,3,8(ที่ดิน)
const POST_DETAIL_PAYMENT = `${BASE_URL_BEN}/api-lawyer/tonbalance`;

//ข้อมูลการผ่อน 8(ไม่ใช่ดิน)
const POST_DETAIL_PAYMENT_LEASING = `${BASE_URL_BEN}/api-lawyer/leasing`;

//หาสัญญาที่ขาดการติดต่อเพื่อส่งสืบทรัพย์ (60 ,120, 180)
const POST_PRE_INVESTIGATE_CHECK = `${BASE_URL_BEN}/api-lawyer/check-miss-call-`;

// memo สืบทรัพย์
const POST_MEMO = `${BASE_URL_BEN}/api-lawyer/load-memo1`;

//หาทุนทรัพย์
const POST_LITIGATION_FUNDS = `${BASE_URL_BEN}/api-lawyer/getleasingcase`;

const POST_CANCEL_LIST = "/api-new/load-work-cancel-contract-new";
const POST_NEW_LOAN = "/api-new/loan-new";

//get GeoThailand ของเอื้อ
const GET_PROVICE = `https://eua-i67f6gaaqa-as.a.run.app/Api/provinces`;
const GET_DISTRICT = `https://eua-i67f6gaaqa-as.a.run.app/Api/districted/`;
const GET_SUB_DISTRICT = `https://eua-i67f6gaaqa-as.a.run.app/Api/subdistricted/`;
const GET_ZIPCODE = `https://eua-i67f6gaaqa-as.a.run.app/Api/zipcodes/`;

//get GeoThailand ที่ดิน
const GET_PROVICE_LAND = `https://onemoney.ngrok.app/GetProvince`;
const POST_DISTRICT_LAND = `https://onemoney.ngrok.app/GetAmphur`;
const POST_CALCULATE_LAND = `https://onemoney.ngrok.app/AllData`;

//get GeoThailand ดริฟ
const GET_PROVICE_DB = `/lawyer/lands/provinces`;
const POST_DISTRICT_DB = `/lawyer/lands/districts`;
const POST_SUB_DISTRICT_DB = `/lawyer/lands/sub-districts`;
// court area
const GET_COURT_AREA = `/lawyer/lands/court`;
// geo ben
const GET_GEO_ALL = `https://api-asset-investigation-539174983798.asia-southeast1.run.app/api-new/data-area`;

const UPLOAD_IMG_WORK_CANCEL = `https://api-uploadimage-lawyer-539174983798.asia-southeast1.run.app/apimg-pdf/upload-pdf`; // อัพโหลด PDF จดหมายตอบรับ
const LOADDATA_WORK_CANCEL = `https://api-asset-investigation-1024031113167.asia-southeast1.run.app/api-ems/load-ems-pdf`; // โหลดข้อมูลจดหมายตอบรับ
const GET_BATCH = `https://api-asset-investigation-1024031113167.asia-southeast1.run.app/api-ems/get-batch`; // โหลดข้อมูลจดหมายตอบรับแบ่งวันที่

const POST_ADD_ADDRESS = "/lawyer/api/address";
const PUT_ADD_ADDRESS = "/lawyer/api/address";

const POST_CEO_CHECK_CONTNO_MISS_CALL = `${BASE_URL_BEN}/api-lawyer/contno-miss-call`;

const GET_CEO_CHECK_MAIN_STATUS = `${baseUrl}/lawyer/api/dashboard/main-status`;

const POST_CEO_CHECK_SUMMARY_MISS_CALL = `${BASE_URL_BEN}/api-lawyer/sum-balanc-smpay`;

export {
  PUT_INVESTIGATE_ITEM_BY_ID,
  POST_INVESTIGATE_ITEM,
  GET_LAND_DETAIL_LIST,
  GET_INVESTIGATE_LOANS_LIST,
  PUT_USER_UPDATE,
  HEADERS_LOGIN,
  GET_LOAN_FROM_SERVER_IBM,
  GET_ALL_LOAN,
  GET_LOAN_BY_CONTNO,
  GET_LAWYERS_LIST,
  GET_JOB_COUNT,
  GET_JOB_IN_PROGRESS,
  GET_JOB_IN_PROGRESS_BY_STATUS,
  POST_LOAN_IN_LAWYERS_DB,
  POST_STATUS,
  PUT_STATUS,
  HEADERS_EXPORT,
  baseUrl,
  GET_LAWSUIT_DETAIL_BY_LOAN,
  PUT_LAWSUIT_DETAIL,
  GET_INVESTIGATE_BY_LAWSUIT,
  GET_INVESTIGATE_LIST,
  POST_INVESTIGATE_LOG,
  PUT_INVESTIGATE_LOG,
  LOG_IN,
  REGISTER,
  GET_WORK_LOG_DETAIL_BY_ID,
  POST_JUDGE,
  PUT_JUDGE,
  GET_JUDGE_BY_ID,
  GET_JUDGE_LIST,
  POST_JUDGE_DEFENDANTS,
  PUT_JUDGE_DEFENDANTS,
  GET_JUDGE_DEFENDANTS_BY_ID,
  GET_COMPANIES_LIST,
  POST_AGREEMENTS,
  PUT_AGREEMENTS,
  GET_AGREEMENTS_BY_ID,
  GET_LAWSUIT_DETAIL_BY_ID,
  GET_LAWSUIT_LIST,
  GET_ROLE_LIST,
  GET_USERS_LIST,
  GET_BY_ID,
  POST_USER,
  GET_PROVICE,
  GET_DISTRICT,
  GET_SUB_DISTRICT,
  GET_ZIPCODE,
  GET_DETAILS,
  GET_PROVICE_LAND,
  POST_DISTRICT_LAND,
  POST_CALCULATE_LAND,
  POST_PARCELS,
  PUT_PARCELS,
  GET_PARCELS,
  POST_TERMINATE_CONTRACT,
  POST_TERMINATE_CONTRACT_RECORD,
  POST_TERMINATE_BY_CONTRACT,
  POST_CANCEL,
  PUT_CANCEL,
  GET_CANCEL,
  POST_EXPENSES,
  PUT_EXPENSES,
  GET_EXPENSES_LIST,
  GET_EXPENSES_LOAN_ID,
  GET_EXPENSES_CONTNO,
  POST_DELETE_ID,
  GET_EXPENSES_CONTNO_LIST,
  GET_EXPENSE_REF_GROUP,
  POST_LOAN_DB2,
  POST_DETAIL_PAYMENT,
  GET_EXPENSE_TYPE_LIST,
  GET_SELL_STATUS,
  POST_EXECUTE_CASE,
  PUT_EXECUTE_CASE,
  GET_EXECUTE_CASE,
  DELETE_WORKLOG,
  DELETE_CANCEL_CONTRACTS,
  DELETE_PARCELS,
  DELETE_AGREEMENTS,
  DELETE_JUDGEMENTS,
  DELETE_JUDGEMENT_DEFENDANTS,
  DELETE_INVESTIGATE_PROPERTIES,
  DELETE_EXPENSES,
  POST_EXPENSES_REFERENCE,
  PUT_EXPENSES_REFERENCE,
  GET_EXPENSES_REFERENCE,
  POST_DETAIL_PAYMENT_LEASING,
  GET_PROVICE_DB,
  POST_DISTRICT_DB,
  POST_SUB_DISTRICT_DB,
  POST_PRE_INVESTIGATE_CHECK,
  POST_RECEIVE_PAYMENT,
  PUT_RECEIVE_PAYMENT,
  GET_RECEIVE_PAYMENT,
  GET_RECEIVE_PAYMENT_BY_PARAMS,
  DELETE_RECEIVE_PAYMENT_BY_ID,
  POST_PRE_INVESTIGATE_LOG,
  POST_PRE_INVESTIGATE_REPORT,
  POST_MEMO,
  HEADERS_EXPORT_BEN,
  POST_LITIGATION_FUNDS,
  BASE_URL_BEN,
  POST_CANCEL_LIST,
  POST_NEW_LOAN,
  UPLOAD_IMG_WORK_CANCEL,
  LOADDATA_WORK_CANCEL,
  GET_BATCH,
  GET_LAND_BY_DATE,
  GET_COURT_AREA,
  GET_GEO_ALL,
  POST_ADD_ADDRESS,
  PUT_ADD_ADDRESS,
  POST_CEO_CHECK_CONTNO_MISS_CALL,
  GET_CEO_CHECK_MAIN_STATUS,
  POST_CEO_CHECK_SUMMARY_MISS_CALL,
};
